import { render, staticRenderFns } from "./TWCustomerShippingmark.vue?vue&type=template&id=541e73ca&scoped=true&"
import script from "./TWCustomerShippingmark.vue?vue&type=script&lang=js&"
export * from "./TWCustomerShippingmark.vue?vue&type=script&lang=js&"
import style0 from "./TWCustomerShippingmark.vue?vue&type=style&index=0&id=541e73ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541e73ca",
  null
  
)

export default component.exports